import React, { useState } from 'react';
import './StatusIndicator.css';

export const StatusIndicator = ({ status, type = 'noType' }) => {
  const [isShown, setIsShown] = useState(true);
  let iconType = null;
  switch (type) {
    case 'success':
      iconType = '/account/static/images/success-check.svg';
      break;
    // TODO add the other status indicator images
    case 'failure':
      iconType = '';
      break;
    case 'warning':
      iconType = '';
      break;
    default:
      iconType = '/account/static/images/delete.svg';
      break;
  }
  return (
    <div className={`statusIndicatorContainer ${type} ${!isShown ? 'closed' : ''}`}>
      <img className="statusIcon" src={iconType} alt="indicator" />
      <div className="statusTitle">{status}</div>
      <button className="statusCloseButton" onClick={() => setIsShown(false)}>
        <img src="/account/static/images/close.svg" width="18" height="19" alt="indicator" />
      </button>
    </div>
  );
};
